import {
  DoveIcon,
  HappyEmojiIcon,
  NeutralEmojiIcon,
  RabbitIcon,
  SadEmojiIcon,
  SnailIcon,
} from '@c/icons';

interface ReviewChipProps {
  rating: 'Good' | 'Bad' | 'Excellent';
  variant: 'communication' | 'shipping';
}

const ReviewChip = ({ rating, variant }: ReviewChipProps) => {
  const getText = () => {
    if (variant === 'communication') return rating;
    else if (variant === 'shipping') {
      if (rating === 'Good') return 'Fast';
      else if (rating === 'Bad') return 'Slow';
      else return 'Average';
    }
  };

  const getIcon = () => {
    if (rating === 'Excellent' && variant === 'communication') {
      return <HappyEmojiIcon />;
    }
    if (rating === 'Excellent' && variant === 'shipping') {
      return <DoveIcon />;
    }
    if (rating === 'Good' && variant === 'communication') {
      return <NeutralEmojiIcon />;
    }
    if (rating === 'Good' && variant === 'shipping') {
      return <RabbitIcon />;
    }

    if (rating === 'Bad' && variant === 'communication') {
      return <SadEmojiIcon />;
    }
    if (rating === 'Bad' && variant === 'shipping') {
      return <SnailIcon />;
    }
  };

  const getStyle = () => {
    if (rating === 'Excellent') return 'bg-[#32D399] text-brand-white';
    if (rating === 'Good') return 'bg-[#D9D9D9] text-black';
    if (rating === 'Bad') return 'bg-[#FF4242] text-brand-white';
  };
  return (
    <div
      className={`flex h-min w-min items-center justify-center gap-[0.8rem] rounded-xl  px-[0.8rem] py-[0.6rem] ${getStyle()}`}
    >
      {getIcon()}
      <span className="text-[1.3rem] font-semibold leading-[2rem] ">
        {getText()}
      </span>
    </div>
  );
};

export default ReviewChip;
